export default __webpack_public_path__ + "static/media/background.1074f735.svg";